/**
 * Section headings that separate a company's own roles from MedScout's standard
 * ones (MKT-530), used wherever roles are listed rather than picked from a
 * dropdown.
 */
export const ROLE_SECTION_COPY = {
  /**
   * "System roles" rather than "MedScout roles" — it matches the wording the
   * Roles & Permissions page already uses in its footnote ("System roles cannot
   * be edited or deleted"), so the page says one thing rather than two.
   */
  standard: 'System roles',
  custom: 'Custom roles',
  /** Sits under the custom heading the first time a viewer meets the idea. */
  customHint: 'Built for your company',
} as const;
